import { Paper, Stack, Typography } from "@mui/material";
import CustomButton from "components/atoms/CustomButton";
import SearchBar from "components/atoms/SearchBar";
import moment from "moment";
import React from "react";
import { exportToExcel } from "utils/exportToExcel";
import PrintIcon from "@mui/icons-material/Print";
import AddIcon from "@mui/icons-material/Add";
import HMOListTable from "components/molecules/tabels/settings/HmoListTable";
import CustomModal from "components/atoms/CustomModal";
import HmoListModals from "components/molecules/settings/HmoListModals";
import { useCustomQuery } from "store/hooks/react-query/query/useQuery";
import { GET_HMOS } from "utils/reactQueryKeys";
import { useSanitizeQueryParams } from "utils/sanitizeQuery";
import CustomLoader from "components/atoms/CustomLoader";

const formatExportData = (data) => {
  if (!data || !data?.length) return;

  const formartted = data.map((d) => {
    return {
      ...d,
    };
  });
  return formartted;
};
const LIMIT = 10;
function HmoList() {
  const modalRef = React.useRef(null);
  const [search, setsearch] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);

  //get vital signs
  const { data, isLoading, isError } = useCustomQuery(
    [
      GET_HMOS,

      {
        search,
        page: currentPage,
      },
    ],
    {
      url: useSanitizeQueryParams(
        `/hmo?search=${search}&page=${currentPage}&limit=${LIMIT}`
      ),
      method: "get",
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  const toggleModal = () => {
    modalRef?.current?.handleToggle();
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleExport = () => {
    exportToExcel(
      formatExportData(data?.data?.data?.results),
      `hmo_list_${moment(new Date(Date.now())).format("MMMM Do, YYYY")}`
    );
  };

  return (
    <Stack spacing={3} width={"100%"}>
      <Stack
        direction={"row"}
        spacing={1}
        gap={{ xs: 1, lg: 0 }}
        sx={{
          flexWrap: "wrap",
        }}
      >
        <SearchBar
          search={search}
          setsearch={setsearch}
          width="100%"
          placeholder="Search HMO Name"
          containerSx={{
            justifyContent: "flex-start",
            width: {
              xs: "100% !important",
              lg: "72% !important",
            },
          }}
        />
        <CustomButton
          variant="outlined"
          text={"Export"}
          onClick={handleExport}
          sx={{ width: "133px" }}
          startIcon={<PrintIcon />}
        />
        <CustomButton
          color="secondary"
          text={"Add HMO"}
          onClick={toggleModal}
          sx={{ width: "133px" }}
          startIcon={<AddIcon />}
        />
      </Stack>

      {isLoading ? (
        <CustomLoader />
      ) : isError ? (
        <Paper sx={{ p: 1 }}>
          <Typography>
            Something went wrong, refresh and try again Later
          </Typography>
        </Paper>
      ) : (
        <Paper sx={{ p: 2 }}>
          {data?.data?.data?.results?.length ? (
            <HMOListTable
              data={{
                hmoList: data?.data?.data?.results,
                count: data?.data?.data?.count,
              }}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          ) : (
            <Typography>No item to display</Typography>
          )}
        </Paper>
      )}

      <CustomModal
        ref={modalRef}
        childrenContSx={{
          p: 3,
          pt: 5,
          height: "fit-content !important",
          width: {
            xs: "90vw",
            sm: "60vw",
            md: "40vw !important",
          },
        }}
      >
        <HmoListModals modalType={"ADD"} />
      </CustomModal>
    </Stack>
  );
}

export default HmoList;
